import type { BariPostPoliReportData } from '@common/validation/customControls/bariPost/bariPostPoliReport/v1/bariPostPoliReportSchemaV1';

export const initialData: BariPostPoliReportData = {
    assets: [],
    hulpvraag: null,
    hulpvraag_aan_expert: null,
    interventie: null,
    verslag: null,
    vervolgstap: null,
};
